import { FermeService } from './ferme.service';
import { map } from 'rxjs/operators/map';
import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { NbTokenService, NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { Ferme } from '../models/ferme.model';
import { CurrentUserService } from './currentUserService';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': '',
  }),
};
@Injectable({
  providedIn: 'root',
})
export class LoadDataService {
  user: {};
  baseUrl: string = environment.apiUrl;
  constructor(private injector: Injector,
              private httpClient: HttpClient,
              private fermeService: FermeService,
              private currentUserService: CurrentUserService) {}

  protected get authService(): NbAuthService {
    return this.injector.get(NbAuthService);
  }

  loadFermes(){
    return new Promise((resolve, reject) => {
        return this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
          if(token.isValid()) {
            if(localStorage.getItem('fermes') === null && localStorage.getItem('selectedFerme') === null){
              this.httpClient
              .get<any[]>(this.baseUrl + '/ferme/' + this.currentUserService.user )
              .subscribe(response => {
                  response.forEach((element, index) => {
                    response[index] = element.ferme;
                  });
                  this.fermeService.grantedFermes = response;
                  this.fermeService.selectedFerme = this.fermeService.grantedFermes[0];
                  localStorage.setItem('selectedFerme', JSON.stringify(this.fermeService.selectedFerme));
                  localStorage.setItem('fermes', JSON.stringify(this.fermeService.grantedFermes));
                  resolve(true);
              })
            }else {
              this.fermeService.selectedFerme = JSON.parse(localStorage.getItem('selectedFerme'));
              this.fermeService.grantedFermes = JSON.parse(localStorage.getItem('fermes'));
              resolve(true);
            }
          }else {
            resolve(true);
          }
        });
    });
  }

  loadUser(){
    return new Promise((resolve, reject) => {
        this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
          if(token.isValid()) {
              this.user = token.getPayload();
              this.currentUserService.user = this.user['id'];
              resolve(true);
          }else {
            resolve(true);
          }
        });
    });
  }
}
